var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderAnim2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 159,
    viewBox: "0 0 158 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.365 57.8764L108.202 63.4284L108.586 67.3112L123.479 60.3857L120.365 57.8764Z",
    fill: "#940006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9343 38.5796L94.6841 51.2565L90.7824 51.2799L96.1133 35.7451L98.9343 38.5796Z",
    fill: "#940006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7859 38.8098L68.892 53.3786L73.4165 50.6743L70.8707 36.5937L66.7859 38.8098Z",
    fill: "#940006"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.847 88.3874L107.138 87.8156L109.355 83.0332L123.624 84.0932L121.847 88.3874Z",
    fill: "#940006"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5014 39.2193C64.114 43.3726 71.0934 43.141 75.0902 38.7021C79.087 34.2633 78.5877 27.2979 73.975 23.1447C69.3624 18.9914 62.383 19.2229 58.3862 23.6618C54.3894 28.1007 54.8887 35.066 59.5014 39.2193Z",
    fill: "#FFBF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2398 38.3992C64.8525 42.5524 71.6665 42.5045 75.4594 38.2921C79.2523 34.0797 78.5877 27.2979 73.975 23.1447C69.3624 18.9914 62.5483 19.0393 58.7554 23.2518C54.9626 27.4642 55.6271 34.2459 60.2398 38.3992Z",
    fill: "#940006"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4307 36.2367C65.8128 40.1824 72.0798 40.366 75.4285 36.6469C78.7772 32.9278 77.9395 26.7143 73.5574 22.7687C69.1754 18.8231 62.9084 18.6394 59.5597 22.3585C56.211 26.0777 57.0487 32.2911 61.4307 36.2367Z",
    fill: "url(#paint0_radial_638_1037)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M61.4315 36.2369C65.8135 40.1825 72.0806 40.3663 75.4293 36.6471C76.1675 35.8255 76.7236 34.8567 77.0618 33.8029C76.3337 34.0793 75.5681 34.2487 74.7886 34.3061C72.5021 34.4712 70.22 33.7721 68.1308 32.7973C65.4293 31.5372 62.8996 29.7551 61.1907 27.3109C60.216 25.9254 59.5662 24.3408 59.2906 22.6768C56.2625 26.4238 57.1719 32.4016 61.4315 36.2369Z",
    fill: "#DBA75C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0908 33.7298C65.7053 35.1834 68.122 35.1313 69.4888 33.6133C70.8556 32.0953 70.6549 29.6863 69.0404 28.2327C67.426 26.779 65.0092 26.8312 63.6424 28.3491C62.2756 29.8671 62.4763 32.2761 64.0908 33.7298Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4311 32.7918C65.8917 34.107 68.0453 34.0965 69.2413 32.7682C70.4372 31.44 70.2226 29.2971 68.7619 27.9819C67.3013 26.6668 65.1477 26.6773 63.9518 28.0055C62.7558 29.3338 62.9704 31.4767 64.4311 32.7918Z",
    fill: "#574120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8837 28.3774C66.4988 28.9312 67.4406 28.8879 67.9873 28.2807C68.5341 27.6735 68.4787 26.7323 67.8636 26.1785C67.2486 25.6247 66.3068 25.668 65.76 26.2752C65.2133 26.8825 65.2687 27.8237 65.8837 28.3774Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8788 31.4972C72.1089 32.6048 73.9924 32.5181 75.0858 31.3038C76.1793 30.0894 76.0685 28.2071 74.8385 27.0996C73.6085 25.9921 71.7249 26.0787 70.6315 27.2931C69.5381 28.5074 69.6488 30.3897 70.8788 31.4972Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.828 94.4381C125.44 98.5913 132.42 98.3598 136.416 93.9209C140.413 89.482 139.914 82.5167 135.301 78.3634C130.689 74.2102 123.709 74.4417 119.712 78.8806C115.716 83.3195 116.215 90.2848 120.828 94.4381Z",
    fill: "#FFBF00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.566 93.6179C126.179 97.7712 132.993 97.7232 136.786 93.5108C140.578 89.2984 139.914 82.5167 135.301 78.3634C130.689 74.2102 123.874 74.2581 120.082 78.4705C116.289 82.6829 116.953 89.4647 121.566 93.6179Z",
    fill: "#940006"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.757 91.4555C127.139 95.4011 133.406 95.5847 136.755 91.8656C140.103 88.1465 139.266 81.933 134.884 77.9874C130.502 74.0418 124.235 73.8582 120.886 77.5773C117.537 81.2964 118.375 87.5099 122.757 91.4555Z",
    fill: "url(#paint1_radial_638_1037)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.757 91.4555C127.14 95.4012 133.407 95.5849 136.755 91.8657C137.493 91.0441 138.05 90.0754 138.388 89.0215C137.66 89.2979 136.894 89.4674 136.115 89.5247C133.828 89.6899 131.546 88.9907 129.457 88.0161C126.755 86.7558 124.226 84.9737 122.517 82.5296C121.542 81.144 120.892 79.5595 120.617 77.8955C117.589 81.6424 118.498 87.6202 122.757 91.4555Z",
    fill: "#DBA75C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.417 88.9485C127.031 90.4022 129.448 90.35 130.815 88.8321C132.182 87.3141 131.981 84.9051 130.367 83.4514C128.752 81.9978 126.335 82.0499 124.969 83.5679C123.602 85.0859 123.803 87.4949 125.417 88.9485Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.757 88.0106C127.218 89.3258 129.372 89.3152 130.567 87.987C131.763 86.6588 131.549 84.5159 130.088 83.2007C128.627 81.8855 126.474 81.8961 125.278 83.2243C124.082 84.5525 124.297 86.6954 125.757 88.0106Z",
    fill: "#574120"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.21 83.5962C127.825 84.15 128.767 84.1067 129.313 83.4995C129.86 82.8922 129.805 81.9511 129.19 81.3973C128.575 80.8435 127.633 80.8868 127.086 81.494C126.539 82.1012 126.595 83.0424 127.21 83.5962Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.205 86.716C133.435 87.8235 135.319 87.7369 136.412 86.5225C137.505 85.3081 137.395 83.4259 136.165 82.3183C134.935 81.2108 133.051 81.2974 131.958 82.5118C130.864 83.7262 130.975 85.6085 132.205 86.716Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8803 39.1807C95.4929 43.334 102.472 43.1025 106.469 38.6636C110.466 34.2247 109.967 27.2594 105.354 23.1061C100.741 18.9528 93.7619 19.1844 89.7651 23.6233C85.7683 28.0621 86.2676 35.0275 90.8803 39.1807Z",
    fill: "#FFBF00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6187 38.3606C96.2314 42.5139 103.045 42.4659 106.838 38.2535C110.631 34.0411 109.967 27.2594 105.354 23.1061C100.741 18.9528 93.9272 19.0008 90.1343 23.2132C86.3415 27.4256 87.006 34.2073 91.6187 38.3606Z",
    fill: "#940006"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8096 36.1982C97.1917 40.1438 103.459 40.3274 106.807 36.6083C110.156 32.8892 109.318 26.6757 104.936 22.7301C100.554 18.7845 94.2873 18.6009 90.9386 22.32C87.5899 26.0391 88.4276 32.2526 92.8096 36.1982Z",
    fill: "url(#paint2_radial_638_1037)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M92.8103 36.1983C97.193 40.1445 103.459 40.3276 106.808 36.6084C107.546 35.7869 108.102 34.8181 108.441 33.7643C107.713 34.0407 106.947 34.2101 106.167 34.2674C103.881 34.4327 101.599 33.7335 99.5097 32.7588C96.8082 31.4986 94.2784 29.7164 92.5695 27.2722C91.5948 25.8867 90.9451 24.3022 90.6695 22.6382C87.6413 26.3853 88.5507 32.3629 92.8103 36.1983Z",
    fill: "#DBA75C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4697 33.6912C97.0842 35.1449 99.5009 35.0927 100.868 33.5747C102.235 32.0568 102.034 29.6478 100.419 28.1941C98.8049 26.7404 96.3881 26.7926 95.0213 28.3106C93.6545 29.8285 93.8553 32.2375 95.4697 33.6912Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.81 32.7533C97.2707 34.0685 99.4242 34.0579 100.62 32.7297C101.816 31.4015 101.602 29.2585 100.141 27.9434C98.6802 26.6282 96.5266 26.6387 95.3307 27.967C94.1347 29.2952 94.3493 31.4381 95.81 32.7533Z",
    fill: "#574120"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2646 28.3394C97.8796 28.8932 98.8214 28.8498 99.3682 28.2426C99.9149 27.6354 99.8596 26.6942 99.2445 26.1404C98.6295 25.5866 97.6876 25.6299 97.1409 26.2372C96.5942 26.8444 96.6495 27.7856 97.2646 28.3394Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.258 31.4587C103.488 32.5662 105.371 32.4796 106.465 31.2652C107.558 30.0508 107.447 28.1685 106.217 27.061C104.987 25.9535 103.104 26.0401 102.01 27.2545C100.917 28.4689 101.028 30.3511 102.258 31.4587Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.07 64.5631C123.682 68.7163 130.662 68.4848 134.659 64.0459C138.655 59.607 138.156 52.6417 133.543 48.4884C128.931 44.3352 121.951 44.5667 117.955 49.0056C113.958 53.4445 114.457 60.4098 119.07 64.5631Z",
    fill: "#FFBF00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.808 63.7429C124.421 67.8962 131.235 67.8482 135.028 63.6358C138.821 59.4234 138.156 52.6417 133.543 48.4884C128.931 44.3352 122.117 44.3831 118.324 48.5955C114.531 52.8079 115.195 59.5897 119.808 63.7429Z",
    fill: "#940006"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M120.999 61.5805C125.381 65.5261 131.648 65.7097 134.997 61.9906C138.346 58.2715 137.508 52.058 133.126 48.1124C128.744 44.1668 122.477 43.9832 119.128 47.7023C115.779 51.4214 116.617 57.6349 120.999 61.5805Z",
    fill: "url(#paint3_radial_638_1037)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M121 61.5806C125.382 65.5262 131.649 65.7099 134.998 61.9908C135.736 61.1692 136.292 60.2004 136.63 59.1466C135.902 59.4229 135.136 59.5924 134.357 59.6497C132.07 59.815 129.788 59.1159 127.699 58.1411C124.998 56.8809 122.468 55.0987 120.759 52.6546C119.784 51.269 119.135 49.6845 118.859 48.0205C115.831 51.7675 116.74 57.7452 121 61.5806Z",
    fill: "#DBA75C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M123.659 59.0735C125.274 60.5272 127.69 60.475 129.057 58.9571C130.424 57.4391 130.223 55.0301 128.609 53.5764C126.994 52.1228 124.578 52.1749 123.211 53.6929C121.844 55.2109 122.045 57.6199 123.659 59.0735Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M123.999 58.1356C125.46 59.4508 127.614 59.4402 128.81 58.112C130.006 56.7838 129.791 54.6409 128.33 53.3257C126.87 52.0105 124.716 52.0211 123.52 53.3493C122.324 54.6775 122.539 56.8204 123.999 58.1356Z",
    fill: "#574120"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M125.452 53.7217C126.067 54.2755 127.009 54.2322 127.556 53.6249C128.102 53.0177 128.047 52.0765 127.432 51.5227C126.817 50.969 125.875 51.0123 125.328 51.6195C124.782 52.2267 124.837 53.1679 125.452 53.7217Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M130.447 56.841C131.677 57.9485 133.561 57.8619 134.654 56.6475C135.748 55.4331 135.637 53.5509 134.407 52.4433C133.177 51.3358 131.293 51.4224 130.2 52.6368C129.106 53.8512 129.217 55.7335 130.447 56.841Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9274 96.8749C21.9274 96.8749 11.0452 87.6506 11.2234 95.8476C11.4015 104.045 33.773 112.133 33.773 112.133L21.9274 96.8749Z",
    fill: "url(#paint4_radial_638_1037)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0841 140.235C70.0841 140.235 80.3955 150.094 72.2246 150.774C64.0537 151.453 53.6715 130.05 53.6715 130.05L70.0841 140.235Z",
    fill: "url(#paint5_radial_638_1037)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6449 116.974C95.8183 126.615 89.9242 142.147 77.4461 143.291C64.2503 144.502 50.4373 130.483 41.7017 122.617C32.966 114.752 17.5804 102.479 17.4047 89.2296C17.2383 76.7004 32.0694 69.2152 41.2572 64.4016C55.6014 56.8864 88.092 39.0223 104.041 53.3824C119.99 67.7425 105.619 101.923 99.6449 116.974Z",
    fill: "url(#paint6_radial_638_1037)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.157 92.9889C112.213 78.3083 113.779 62.1503 104.041 53.3822C88.0922 39.0219 55.6014 56.8863 41.2571 64.4014C33.2879 68.5767 21.0799 74.7642 18.0884 84.5071C19.9551 81.7373 22.2574 79.2892 24.908 77.2557C33.9761 70.3407 83.0439 39.1216 100.787 53.3438C110.305 60.9736 110.293 78.3905 108.157 92.9889Z",
    fill: "#FFBF00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4395 55.3369C78.4395 55.3369 82.4616 73.7509 103.608 77.9992C103.608 77.9992 84.0707 67.8035 78.4395 55.3369Z",
    fill: "#940006"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M79.883 59.5234C79.883 59.5234 84.3385 54.1616 85.6294 54.5887C86.9202 55.0158 90.0389 60.0294 90.0389 60.0294L82.8715 64.6744L79.883 59.5234Z",
    fill: "#FFDEF8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2876 76.8292C99.2876 76.8292 104.198 71.7929 103.638 70.5538C103.079 69.3147 97.7665 66.7372 97.7665 66.7372L93.8477 74.6042L99.2876 76.8292Z",
    fill: "#FFDEF8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.3522 100.535C24.0184 101.378 24.7035 102.208 25.4167 103.015C32.064 110.537 40.9213 116.494 49.4494 121.69C57.375 126.52 65.8549 130.9 74.7511 133.589C79.5081 135.027 84.7408 136.208 89.7317 136.078C94.3849 130.45 97.3774 122.682 99.6431 116.974C99.9546 116.189 100.291 115.346 100.643 114.463C86.7487 118.466 70.5279 115.553 57.2975 110.298C47.5554 106.429 38.2969 100.947 30.7982 93.5408C27.2278 89.98 24.0921 86.0102 21.458 81.7163C21.0909 81.1241 20.7121 80.4985 20.336 79.8486C19.0399 81.7926 18.1004 83.906 17.6704 86.2054C17.6708 86.2053 18.8289 92.7965 23.3522 100.535Z",
    fill: "#940006"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4606 64.8907C40.4606 64.8907 47.1161 96.0172 53.3198 93.225C59.5235 90.4329 53.01 62.4261 49.7036 62C46.3971 61.5739 41.1173 62.9322 40.4606 64.8907Z",
    fill: "url(#paint7_radial_638_1037)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7039 61.9999C46.4294 61.5773 41.2191 62.9071 40.4834 64.8361C42.4429 64.2633 44.5092 64.1256 46.5387 64.4326C48.105 64.6742 49.711 65.2334 50.7555 66.4325C51.5977 67.3991 51.9815 68.6677 52.3291 69.8969C54.3336 76.986 55.8593 84.7285 53.1157 91.5049C52.8581 92.1542 52.5418 92.778 52.1707 93.3687C52.561 93.4411 52.9627 93.3908 53.3201 93.2249C59.5238 90.4327 53.0096 62.4263 49.7039 61.9999Z",
    fill: "#FFBF00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4308 117.021C99.4308 117.021 67.7792 113.655 69.9076 107.194C72.036 100.732 100.57 104.283 101.34 107.526C102.11 110.769 101.31 116.163 99.4308 117.021Z",
    fill: "url(#paint8_radial_638_1037)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M101.34 107.526C102.102 110.739 101.324 116.06 99.4826 116.993C99.8475 114.984 99.7684 112.915 99.2509 110.929C98.8469 109.396 98.123 107.857 96.8212 106.944C95.7718 106.208 94.4702 105.958 93.2114 105.741C85.9516 104.488 78.092 103.781 71.6394 107.218C71.0206 107.542 70.4332 107.921 69.8845 108.352C69.7717 107.972 69.7798 107.567 69.9075 107.194C72.0361 100.732 100.57 104.284 101.34 107.526Z",
    fill: "#FFBF00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0693 20.2151) rotate(42) scale(22.9 22.5995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.374 75.4143) rotate(42) scale(22.9 22.5995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.442 20.171) rotate(42) scale(22.9 22.5995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.622 45.5444) rotate(42) scale(22.9 22.5995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#FFECD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBA75C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-132.315 -32.2474) rotate(42) scale(29.9736 29.5482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-270.215 -156.413) rotate(-138) scale(29.9735 29.5482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.5208 78.7018) rotate(42) scale(64.4681 63.6619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.29544 16.1519) rotate(42) scale(40.938 40.4162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_638_1037",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-363.36 -314.053) rotate(-138) scale(40.938 40.416)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992,
    stopColor: "#FF0000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderAnim2);
export default __webpack_public_path__ + "static/media/headerAnim2.30b3a0c8a2b6e8fe185500f0b4e60ca7.svg";
export { ForwardRef as ReactComponent };